import { environment } from '../../../../../../environments/environment';
import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioService } from '../../../services/usuario.service';
import { ServicoService } from '../../../services/servico.service';
import { NgxSpinnerService } from 'ngx-spinner';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
declare var L: any;


@Component({
  selector: 'app-servicos-recadastro',
  standalone: false,
  templateUrl: './servicos-recadastro.component.html',
  styleUrl: './servicos-recadastro.component.css'
})
export class ServicosRecadastroComponent implements OnInit {
  getFullImageUrl(url: string): string {
    if (!url) return '';
    if (/^https?:\/\//.test(url)) return url;
    return environment.mediaUrl.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
  }
  // Filtros
  filtroUsuarioId: string = '';
  filtroDataInicio: string = this.getDataSeteDiasAtrasInput();
  filtroDataFim: string = this.getDataHojeInput();
  usuariosFiltro: { usuarioId: string, nome: string }[] = [];
  // Filtros adicionais copied from cadastro
  showFiltros: boolean = false;
  filtroStatus: string = '';
  filtroNumeroOrdem: number | null = null;
  filtroMatricula: string = '';
  filtroNomeConsumidor: string = '';
  filtroCpf: string = '';
  filtroCnpj: string = '';
  filtroCep: string = '';
  filtroLogradouro: string = '';
  filtroBairro: string = '';
  filtroCidade: string = '';
  filtroEstado: string = '';
  filtroNumero: string = '';
  filtroNumeroVistoria: string = '';

  recadastros: any[] = [];
  recadastrosFiltrados: any[] = [];
  carregando = false;
  erro: string | null = null;
  recadastroDetalhes: any = null;
  mostrarModalFoto = false;
  fotoSelecionada = '';

  // Referência ao Math para uso no template
  Math = Math;

  // Paginação
  paginaAtual = 1;
  tamanhoPagina = 50;
  totalItens = 0;
  totalPaginas = 0;

  @ViewChild('conteudoModal', { static: false }) conteudoModal!: ElementRef;
  htmlCompletoParaExportar: string = '';

  constructor(
    private usuarioService: UsuarioService,
    private servicoService: ServicoService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Buscar colaboradores e popular filtro
    this.usuarioService.carregarTodosColaboradores().subscribe({
      next: (colaboradores) => {
        this.usuariosFiltro = colaboradores
          .map((u: any) => ({ usuarioId: u.usuarioId, nome: u.nome }))
          .filter(u => !!u.usuarioId && !!u.nome);
      },
      error: () => {
        this.usuariosFiltro = [];
      }
    });

    this.recadastros = [];
    this.recadastrosFiltrados = [];
  }

  aplicarFiltro(): void {
    this.spinner.show();
    this.erro = null;
    this.paginaAtual = 1; // Reset para primeira página

    if (!this.filtroUsuarioId) {
      // Quando "Todos" está selecionado, usar o método obterTodosRecadastro
      const dataInicio = this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined;
      const dataFim = this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined;
      // Note: obterTodosRecadastro signature expects (dataInicio?, dataFim?, pagina?, tamanhoPagina?, status?)
      this.servicoService.obterTodosRecadastro(dataInicio, dataFim, this.paginaAtual, this.tamanhoPagina, 'Validado').subscribe({
        next: (response) => {
          this.recadastros = response?.itens || response?.items || response?.recadastros || [];
          this.recadastrosFiltrados = this.recadastros;
          this.aplicarFiltrosLocais();
          this.atualizarInformacoesPaginacao(response);
          this.spinner.hide();
        },
        error: (err) => {
          this.recadastros = [];
          this.recadastrosFiltrados = [];
          this.spinner.hide();
        }
      });
      return;
    }

    // Formatar datas para ISO completo (yyyy-MM-ddTHH:mm:ss)
    const dataInicio = this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined;
    const dataFim = this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined;

    this.servicoService.obterRecadastrosPorIntervalo(
      this.filtroUsuarioId,
      dataInicio,
      dataFim,
      this.paginaAtual,
      this.tamanhoPagina,
      'Validado'
    ).subscribe({
      next: (response) => {
        this.recadastros = response?.itens || response?.items || response?.recadastros || response || [];
        this.recadastrosFiltrados = this.recadastros;
        this.aplicarFiltrosLocais();
        // Atualiza paginação conforme resposta
        this.atualizarInformacoesPaginacao(response);
        this.spinner.hide();
      },
      error: (err) => {
        this.recadastros = [];
        this.recadastrosFiltrados = [];
        this.spinner.hide();
      }
    });
  }



  verDetalhes(registro: any): void {
    // Detecta se é TV (tela grande)
    const isTV = window.innerWidth >= 1200;

    if (isTV) {
      const ZERO_UUID = '00000000-0000-0000-0000-000000000000';
      let idParaBuscar = registro.recadastroId && registro.recadastroId !== ZERO_UUID
        ? registro.recadastroId
        : registro.id;
      if (!idParaBuscar || idParaBuscar === ZERO_UUID) {
        console.warn('[TV] Nenhum ID válido encontrado para registro:', registro);
        return;
      }
      this.spinner.show();
      this.servicoService.obterRecadastroPorId(idParaBuscar).subscribe({
        next: (detalhes) => {
          const queryParams: any = {};
          if (detalhes?.usuarioId) {
            queryParams.usuarioId = detalhes.usuarioId;
          }
          const idJuncao = detalhes?.idJuncao || detalhes?.IdJuncao || detalhes?.idjuncao || detalhes?.idJuncaoFk;
          if (idJuncao && idJuncao !== ZERO_UUID) {
            queryParams.idJuncao = idJuncao;
            this.servicoService.obterDetalhesporIdJuncao(idJuncao).subscribe({
              next: (detalhesCompletos) => {
                const dataEvento = detalhesCompletos?.dataHoraInicio || detalhes?.dataHoraInicio;
                if (dataEvento) {
                  const day = new Date(dataEvento).toISOString().split('T')[0];
                  queryParams.filtroDataInicio = `${day}T00:00:00`;
                  queryParams.filtroDataFim = `${day}T23:59:59`;
                }
                if (detalhesCompletos?.recadastroId || detalhes?.recadastroId) {
                  queryParams.recadastroId = detalhesCompletos?.recadastroId || detalhes?.recadastroId;
                }
                this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
                  .finally(() => this.spinner.hide());
              },
              error: (err) => {
                console.error('[TV] Erro ao buscar detalhes por idJuncao', err);
                const dataEvento = detalhes?.dataHoraInicio;
                if (dataEvento) {
                  const day = new Date(dataEvento).toISOString().split('T')[0];
                  queryParams.filtroDataInicio = `${day}T00:00:00`;
                  queryParams.filtroDataFim = `${day}T23:59:59`;
                }
                queryParams.recadastroId = idParaBuscar;
                this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
                  .finally(() => this.spinner.hide());
              }
            });
            return;
          }
          // Se não tem idJuncao, usar período da data do evento
          const dataEvento = detalhes?.dataHoraInicio;
          if (dataEvento) {
            const day = new Date(dataEvento).toISOString().split('T')[0];
            queryParams.filtroDataInicio = `${day}T00:00:00`;
            queryParams.filtroDataFim = `${day}T23:59:59`;
          }
          queryParams.recadastroId = idParaBuscar;
          this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
            .finally(() => this.spinner.hide());
        },
        error: (err) => {
          console.error('[TV] Erro ao buscar detalhes do recadastro', err);
          this.spinner.hide();
          alert('Erro ao carregar detalhes para navegação.');
        }
      });
      return;
    }
    // Caso NÃO seja TV, abrir modal normalmente
    this.spinner.show();
    this.recadastroDetalhes = null;
    this.servicoService.obterRecadastroPorId(registro.recadastroId || registro.id).subscribe({
      next: (detalhes) => {
        this.spinner.hide();
        this.recadastroDetalhes = detalhes;
        setTimeout(() => this.inicializarMapaRecadastro(), 350);
      },
      error: () => {
        this.spinner.hide();
        alert('Erro ao buscar detalhes do recadastro.');
      }
    });
  }


  inicializarMapaRecadastro(): void {
    // Remove mapa anterior se existir
    if ((window as any)._mapCadastro) {
      (window as any)._mapCadastro.remove();
      (window as any)._mapCadastro = null;
    }

    const latInicio = this.recadastroDetalhes?.latitudeInicio;
    const lngInicio = this.recadastroDetalhes?.longitudeInicio;
    const latFim = this.recadastroDetalhes?.latitudeFim;
    const lngFim = this.recadastroDetalhes?.longitudeFim;
    const divMapa = document.getElementById('map-recadastro');
    if (!divMapa) return;

    divMapa.innerHTML = '';
    divMapa.style.height = '220px';
    divMapa.style.width = '100%';

    // Só mostra o mapa se pelo menos um ponto existir
    if ((latInicio && lngInicio) || (latFim && lngFim)) {
      let centerLat: number;
      let centerLng: number;
      if (latInicio && lngInicio && latFim && lngFim) {
        centerLat = (Number(latInicio) + Number(latFim)) / 2;
        centerLng = (Number(lngInicio) + Number(lngFim)) / 2;
      } else if (latFim && lngFim) {
        centerLat = Number(latFim);
        centerLng = Number(lngFim);
      } else {
        centerLat = Number(latInicio);
        centerLng = Number(lngInicio);
      }
      const map = L.map('map-recadastro').setView([centerLat, centerLng], 16);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap'
      }).addTo(map);

      // Marcador início (azul)
      if (latInicio && lngInicio) {
        const inicioIcon = L.icon({
          iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoInicio.png',
          iconSize: [48, 48],
          iconAnchor: [24, 48],
          popupAnchor: [0, -45]
        });
        L.marker([latInicio, lngInicio], { icon: inicioIcon }).addTo(map).bindPopup('Início da Vistoria');
      }

      // Marcador fim (vermelho)
      if (latFim && lngFim) {
        const fimIcon = L.icon({
          iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoFim.png',
          iconSize: [48, 48],
          iconAnchor: [24, 48],
          popupAnchor: [0, -45]
        });
        L.marker([latFim, lngFim], { icon: fimIcon }).addTo(map).bindPopup('Fim da Vistoria');
      }

      (window as any)._mapCadastro = map;
    } else {
      divMapa.innerHTML = '<div style="text-align:center;padding:40px 0;color:#888;">Sem coordenadas para exibir o mapa.</div>';
      divMapa.style.height = '120px';
    }
  }
  fecharModalDetalhes(): void {
    this.recadastroDetalhes = null;
  }

  fecharModalFoto(): void {
    this.mostrarModalFoto = false;
    this.fotoSelecionada = '';
  }

  // Store rotations for photos keyed by URL
  private photoRotations: { [key: string]: number } = {};

  abrirModalFoto(url: string): void {
    this.fotoSelecionada = this.getFullImageUrl(url);
    this.mostrarModalFoto = true;
  }

  rotatePhoto(url: string | undefined, delta: number): void {
    if (!url) return;
    const key = this.getFullImageUrl(url);
    const current = this.photoRotations[key] || 0;
    // Ensure rotation steps of 90 degrees
    const next = (current + delta + 360) % 360;
    this.photoRotations[key] = next;
  }

  getPhotoRotation(url: string | undefined): number {
    if (!url) return 0;
    const key = this.getFullImageUrl(url);
    return this.photoRotations[key] || 0;
  }

  

  resetarFiltro(): void {
    this.filtroUsuarioId = '';
    this.filtroDataInicio = this.getDataSeteDiasAtrasInput();
    this.filtroDataFim = this.getDataHojeInput();
    this.recadastros = [];
    this.recadastrosFiltrados = [];
    this.erro = null;
    // Reset paginação
    this.paginaAtual = 1;
    this.totalItens = 0;
    this.totalPaginas = 0;
    // reset filtros adicionais
    this.showFiltros = false;
    this.filtroStatus = '';
    this.filtroNumeroOrdem = null;
    this.filtroMatricula = '';
    this.filtroNomeConsumidor = '';
    this.filtroCpf = '';
    this.filtroCnpj = '';
    this.filtroCep = '';
    this.filtroLogradouro = '';
    this.filtroBairro = '';
    this.filtroCidade = '';
    this.filtroEstado = '';
    this.filtroNumero = '';
    this.filtroNumeroVistoria = '';
  }

  // Método para resetar e recarregar imediatamente
  resetarERecarregar(): void {
    this.resetarFiltro();
    this.aplicarFiltro();
  }

  alterarTamanhoPagina(novoTamanho: any): void {
    const tamanho = Number(novoTamanho) || 50;
    this.tamanhoPagina = tamanho;
    this.aplicarFiltro();
  }

  // Método para alternar filtros com detecção de mudança
  toggleFiltros(): void {
    this.showFiltros = !this.showFiltros;
    this.cdr.markForCheck();
  }

  private aplicarFiltrosLocais(): void {
    if (!this.recadastros || this.recadastros.length === 0) {
      this.recadastrosFiltrados = [];
      return;
    }

    const statusFiltro = (this.filtroStatus || '').toString().trim().toLowerCase();
    const matriculaFiltro = (this.filtroMatricula || '').toString().trim().toLowerCase();
    const nomeFiltro = (this.filtroNomeConsumidor || '').toString().trim().toLowerCase();
    const numeroFiltro = (this.filtroNumeroVistoria || '').toString().trim().toLowerCase();

    this.recadastrosFiltrados = this.recadastros.filter(s => {
      // status
      if (statusFiltro) {
        // Check both 'status' and 'statusOS' (and effectiveStatus) so local filtering matches server behaviour
        const sStatus = (s.status || '').toString().toLowerCase();
        const sStatusOS = (s.statusOS || s.statusOs || s.status_os || '').toString().toLowerCase();
        const eff = (this.effectiveStatus(s) || '').toString().toLowerCase();
        if (!(sStatus.includes(statusFiltro) || sStatusOS.includes(statusFiltro) || eff.includes(statusFiltro))) return false;
      }

      // matricula
      if (matriculaFiltro) {
        const sMat = (s.matricula || s.matriculaConsumidor || s.matriculaUsuario || '').toString().toLowerCase();
        if (!sMat.includes(matriculaFiltro)) return false;
      }

      // nome consumidor
      if (nomeFiltro) {
        const sNome = (s.nomeConsumidor || s.nome || '').toString().toLowerCase();
        if (!sNome.includes(nomeFiltro)) return false;
      }

      // numero (Nº Vistoria) - comparar com varios campos incluindo numeroOS
      if (numeroFiltro) {
        const candidatosNumero = [
          s.numeroOS, s.numeroOs, s.numeroOrdemFormatado, s.numeroOrdem, s.numero, s.ordemNumero
        ];

        const numeroFiltroSemZeros = numeroFiltro.replace(/^0+/, '');

        const encontradoNumero = candidatosNumero.some((c: any) => {
          if (c === undefined || c === null) return false;
          const cs = c.toString().toLowerCase();
          // comparar tanto com zeros quanto sem zeros à esquerda
          if (cs.includes(numeroFiltro)) return true;
          if (cs.replace(/^0+/, '').includes(numeroFiltroSemZeros)) return true;
          return false;
        });

        if (!encontradoNumero) return false;
      }

      return true;
    });
  }

  exportarRecadastroParaPDF(): void {
    if (!this.recadastroDetalhes) return;

    // Salva os dados do serviço antes de fechar o modal
    const dadosServico = { ...this.recadastroDetalhes };

    // Busca o modal-body original
    const modalBodyOriginal = document.querySelector('.modal-body') as HTMLElement;
    if (!modalBodyOriginal) return;

    // Cria um clone do modal-body para captura
    const modalBodyClone = modalBodyOriginal.cloneNode(true) as HTMLElement;

    // Configura o clone para captura completa mas visível para html2canvas
    modalBodyClone.style.position = 'absolute';
    modalBodyClone.style.top = '-9999px';
    modalBodyClone.style.left = '-9999px';
    modalBodyClone.style.overflow = 'visible';
    modalBodyClone.style.maxHeight = 'none';
    modalBodyClone.style.height = 'auto';
    modalBodyClone.style.width = modalBodyOriginal.offsetWidth + 'px';
    modalBodyClone.style.visibility = 'visible';
    modalBodyClone.style.pointerEvents = 'none';
    modalBodyClone.style.opacity = '1';

    // Adiciona o clone ao body temporariamente
    document.body.appendChild(modalBodyClone);

    // Fecha o modal imediatamente para melhor UX
    this.fecharModalDetalhes();

    // Aguarda um momento para o clone renderizar completamente
    setTimeout(() => {
      html2canvas(modalBodyClone, {
        scale: 1,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        scrollX: 0,
        scrollY: 0,
        logging: true,
        width: modalBodyClone.scrollWidth,
        height: modalBodyClone.scrollHeight
      }).then((canvas: HTMLCanvasElement) => {
        document.body.removeChild(modalBodyClone);


        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = 210;
        const pdfHeight = 297;
        const margin = 8;
        const contentWidth = pdfWidth - (margin * 2);
        const pageContentHeight = pdfHeight - (margin * 2);

        // Proporção da imagem para o PDF
        const imgWidth = contentWidth;
        const imgHeight = (canvas.height * contentWidth) / canvas.width;

        // Altura do canvas em pixels correspondente a uma página PDF
        const pageHeightPx = Math.floor((pageContentHeight * canvas.height) / imgHeight);
        const minRestPx = 100; // altura mínima para não cortar elemento grande
        let renderedHeight = 0;
        let pageNum = 1;

        while (renderedHeight < canvas.height) {
          let pageCanvasHeight = Math.min(pageHeightPx, canvas.height - renderedHeight);
          // Se o restante do canvas for menor que minRestPx, pule para próxima página
          if (canvas.height - (renderedHeight + pageCanvasHeight) < minRestPx && (canvas.height - renderedHeight) > pageHeightPx) {
            pageCanvasHeight = canvas.height - renderedHeight - minRestPx;
          }

          const pageCanvas = document.createElement('canvas');
          const pageCtx = pageCanvas.getContext('2d');
          pageCanvas.width = canvas.width;
          pageCanvas.height = pageCanvasHeight;

          // Copia a parte do canvas para a página
          pageCtx?.drawImage(
            canvas,
            0, renderedHeight, canvas.width, pageCanvasHeight,
            0, 0, canvas.width, pageCanvasHeight
          );

          const pageImgData = pageCanvas.toDataURL('image/png');
          const pageImgHeight = (pageCanvasHeight * imgWidth) / canvas.width;

          if (pageNum > 1) pdf.addPage();
          pdf.addImage(pageImgData, 'PNG', margin, margin, imgWidth, pageImgHeight);

          renderedHeight += pageCanvasHeight;
          pageNum++;
        }

        // Usa os dados salvos para o nome do arquivo
        const nome = dadosServico?.nomeConsumidor?.replace(/\s/g, '_') || 'servico';
        pdf.save(`${nome}_servico.pdf`);
      }).catch((error: any) => {
        console.error('Erro ao gerar PDF:', error, error?.message, error?.stack);
        // Remove o clone em caso de erro
        if (document.body.contains(modalBodyClone)) {
          document.body.removeChild(modalBodyClone);
        }
        alert('Erro ao gerar o PDF. Tente novamente.');
      });
    }, 500);
  }

  onFiltroDataFimChange(): void {
    // If no end date selected, do nothing (user may be clearing the filter)
    if (!this.filtroDataFim) {
      return;
    }

    // Allow the ngModel binding to settle, then apply the filter.
    setTimeout(() => {
      try {
        this.aplicarFiltro();
      } catch (e) {
        // swallow to avoid breaking UI; spinner/error handling is inside aplicarFiltro
        console.error('Erro ao aplicar filtro automaticamente por data fim', e);
      }
    }, 50);
  }
  getDataHojeInput(): string {
    const hoje = new Date();
    return hoje.toISOString().split('T')[0];
  }

  getDataSeteDiasAtrasInput(): string {
    const hoje = new Date();
    const seteDiasAtras = new Date(hoje);
    // Subtract 7 days to get the date 7 days ago (inclusive range)
    seteDiasAtras.setDate(hoje.getDate() - 0);
    return seteDiasAtras.toISOString().split('T')[0];
  }

  maskCpf(cpf: string): string {
    if (!cpf) return '-';
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) return cpf;
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  maskCnpj(cnpj: any): string {
    if (!cnpj) return '-';
    cnpj = String(cnpj).replace(/\D/g, '');
    if (cnpj.length !== 14) return cnpj;
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  maskTelefone(telefone: string): string {
    if (!telefone) return '-';
    telefone = telefone.replace(/\D/g, '');
    if (telefone.length === 11) {
      return telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    if (telefone.length === 10) {
      return telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    return telefone;
  }

  recadastroTipoUtilizacaoDomiciliar(): boolean {
    // Retorna true se todos os recadastros filtrados são domiciliares
    return this.recadastrosFiltrados.every(r => r.tipoUtilizacao === 'DOMICILIAR');
  }

  // Métodos de paginação
  private atualizarInformacoesPaginacao(response: any): void {
    this.totalItens = response?.totalItens || 0;
    this.totalPaginas = response?.totalPaginas || 0;
    this.paginaAtual = response?.paginaAtual || 1;
    this.tamanhoPagina = response?.tamanhoPagina || 10;
  }

  irParaPagina(pagina: number): void {
    if (pagina >= 1 && pagina <= this.totalPaginas && pagina !== this.paginaAtual) {
      this.paginaAtual = pagina;
      this.carregarPagina();
    }
  }

  paginaAnterior(): void {
    if (this.paginaAtual > 1) {
      this.irParaPagina(this.paginaAtual - 1);
    }
  }

  proximaPagina(): void {
    if (this.paginaAtual < this.totalPaginas) {
      this.irParaPagina(this.paginaAtual + 1);
    }
  }

  private carregarPagina(): void {
    if (!this.filtroUsuarioId) {
      // Apenas para "Todos" - carrega nova página
      this.spinner.show();
      const dataInicio = this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined;
      const dataFim = this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined;
      // same reorder for pagination flow
      this.servicoService.obterTodosRecadastro(dataInicio, dataFim, this.paginaAtual, this.tamanhoPagina, 'Validado').subscribe({
        next: (response) => {
          this.recadastros = response?.itens || response?.items || response?.recadastros || [];
          this.recadastrosFiltrados = this.recadastros;
          this.atualizarInformacoesPaginacao(response);
          this.spinner.hide();
        },
        error: (err) => {
          this.recadastros = [];
          this.recadastrosFiltrados = [];
          this.erro = 'Erro ao buscar recadastros.';
          this.spinner.hide();
        }
      });
    }
    // Para filtros específicos, usa paginação e status "Validado"
    else {
      const dataInicio = this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined;
      const dataFim = this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined;
      this.spinner.show();
      this.servicoService.obterRecadastrosPorIntervalo(
        this.filtroUsuarioId,
        dataInicio,
        dataFim,
        this.paginaAtual,
        this.tamanhoPagina,
        'Validado'
      ).subscribe({
        next: (response) => {
          this.recadastros = response?.recadastros || response?.itens || response?.items || [];
          this.recadastrosFiltrados = this.recadastros;
          this.atualizarInformacoesPaginacao(response);
          this.spinner.hide();
        },
        error: (err) => {
          this.recadastros = [];
          this.recadastrosFiltrados = [];
          this.erro = 'Erro ao buscar recadastros.';
          this.spinner.hide();
        }
      });
    }
  }

  // Método para gerar array de páginas para o paginador
  obterPaginas(): number[] {
    const paginas = [];
    const maxPaginasVisiveis = 5;
    const metade = Math.floor(maxPaginasVisiveis / 2);

    let inicio = Math.max(1, this.paginaAtual - metade);
    let fim = Math.min(this.totalPaginas, inicio + maxPaginasVisiveis - 1);

    // Ajusta o início se estivermos próximos do fim
    if (fim - inicio < maxPaginasVisiveis - 1) {
      inicio = Math.max(1, fim - maxPaginasVisiveis + 1);
    }

    for (let i = inicio; i <= fim; i++) {
      paginas.push(i);
    }

    return paginas;
  }

  effectiveStatus(servico: any): string {
    if (!servico) return '';
    const statusRaw = (servico.status || '').toString();
    const status = statusRaw.toLowerCase();
    const statusOS = (servico.statusOS || servico.statusOs || servico.status_os || '').toString();

    // Se status indica um dos casos em que devemos priorizar o próprio status:
    if (['analisando', 'validado', 'invalido'].includes(status)) {
      return statusRaw;
    }

    if (statusOS) return statusOS;

    return statusRaw || '';
  }
}
